export enum PolicyStatusConstants {
    ENROLED = 'ENROLED',
    PENDING = 'PENDING',
    NOT_SELECTED = 'NOT_SELECTED',
    NOT_AVAILABLE = 'NOT_AVAILABLE'
}
